import { Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Painel from "./Painel";
import { useMaterialUIController } from "context";

// Status (subiu/caiu) sempre com seta + texto, nunca só pela cor
const COR_SUBIU = { light: "#006300", dark: "#0ca30c" };
const COR_CAIU = { light: "#d03b3b", dark: "#e66767" };

const comAlfa = (hex, alfa) => {
    const valor = hex.replace("#", "");
    const [r, g, b] = [0, 2, 4].map(i => parseInt(valor.substring(i, i + 2), 16));
    return `rgba(${r}, ${g}, ${b}, ${alfa})`;
};

/**
 * Indicador do topo da tela (número em destaque, sem gráfico).
 * variacao: { texto: "+8,2%", positiva: true } ou null quando não há comparação.
 */
export default function KpiCard({ icone, cor, rotulo, valor, detalhe, variacao, rotuloVariacao }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const modo = darkMode ? "dark" : "light";

    return (
        <Painel>
            <MDBox display="flex" alignItems="flex-start" gap={2}>
                <MDBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        width: 52,
                        height: 52,
                        minWidth: 52,
                        borderRadius: "50%",
                        background: comAlfa(cor, darkMode ? 0.22 : 0.12),
                    }}
                >
                    <Icon sx={{ color: cor, fontSize: "1.6rem !important" }}>{icone}</Icon>
                </MDBox>
                <MDBox minWidth={0}>
                    <MDTypography variant="button" color="text" sx={{ display: "block", fontWeight: 500 }}>
                        {rotulo}
                    </MDTypography>
                    <MDTypography variant="h4" fontWeight="bold" color="text" sx={{ lineHeight: 1.25, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {valor}
                    </MDTypography>
                    {variacao ? (
                        <MDBox display="flex" alignItems="center" gap={0.5} flexWrap="wrap">
                            <Icon sx={{ color: (variacao.positiva ? COR_SUBIU : COR_CAIU)[modo], fontSize: "1rem !important" }}>
                                {variacao.positiva ? "arrow_upward" : "arrow_downward"}
                            </Icon>
                            <MDTypography variant="button" fontWeight="bold" sx={{ color: `${(variacao.positiva ? COR_SUBIU : COR_CAIU)[modo]} !important` }}>
                                {variacao.texto}
                            </MDTypography>
                            <MDTypography variant="caption" color="text" sx={{ opacity: 0.8 }}>
                                {rotuloVariacao}
                            </MDTypography>
                        </MDBox>
                    ) : (
                        detalhe && (
                            <MDTypography variant="caption" color="text" sx={{ display: "block", opacity: 0.8 }}>
                                {detalhe}
                            </MDTypography>
                        )
                    )}
                </MDBox>
            </MDBox>
        </Painel>
    );
}
